import { breakpointsTailwind, useWindowSize } from '@vueuse/core';
import { computed } from 'vue';

export function useMobile() {
  const { width } = useWindowSize();

  const isMobile = computed(() => width.value <= breakpointsTailwind.md);


  return {
    isMobile,
  };
}

export function useTablet() {
  const { width } = useWindowSize();

  const isTablet = computed(() => width.value <= breakpointsTailwind.lg);

  return {
    isTablet,
  };
}
